import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
/** We have to wrap this badge with a tooltip outside of da-ds since tooltips still live in da-shared-react */
var TierBadgeWithTooltip = function (_a) {
    var isLocked = _a.isLocked, rest = __rest(_a, ["isLocked"]);
    var t = useTranslation().t;
    return (React.createElement(SimpleTooltip, { placement: "bottom", text: t(isLocked ? 'tierBadge.locked.tooltip' : 'tierBadge.unlocked.tooltip') },
        React.createElement(TierBadge, __assign({ isLocked: isLocked }, rest))));
};
TierBadgeWithTooltip.displayName = 'TierBadgeWithTooltip';
export default TierBadgeWithTooltip;
//# sourceMappingURL=TierBadgeWithTooltip.js.map